import log from "loglevel";

import config from "./config";

log.setLevel(config.logLevel);
log.setDefaultLevel(config.logLevel);
